module.exports = "<div >\n    <deployed-packages-details-filter (filter)=\"filter($event)\"></deployed-packages-details-filter>\n    <deployed-packages-details-data [data]=\"tableData\" [resetSize] = \"resetSize\" [Criteria]=\"Criteria\" (flagpag) = \"flagpag($event)\"  (filter)=\"filter($event)\" (getRecords)=\"getRecords($event)\"></deployed-packages-details-data>\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/authorized/reports/deployed-packages-details/deployed-details-packages.component.html
// module id = 1825
// module chunks = 0